module.exports = __webpack_public_path__ + "img/mobilehardwareOpen1.65465ad0.png";